export class FileAlreadyExistsNotification extends Error {
    DisplayMessage: string;
    /**
     *
     */
    constructor(message:string, displayMessage: string) {
        super(message);
        
        this.DisplayMessage = displayMessage;
    }
}